import { AgGauge } from 'ag-charts-react';

import type { RadialGaugeProps } from './RadialGaugeChart.types';

const RadialGauge = ({ classes, options, onClick }: RadialGaugeProps) => {
  const containerContent = (
    <div className={classes.radialGaugeContainer}>
      <AgGauge className={classes.radialGaugeChart} options={options} />
    </div>
  );

  if (onClick) {
    return (
      <div
        className={classes.radialGaugeWrapper}
        onClick={onClick}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
          }
        }}
        role="button"
        tabIndex={0}
      >
        {containerContent}
      </div>
    );
  }

  return <div className={classes.radialGaugeWrapper}>{containerContent}</div>;
};

RadialGauge.displayName = 'RadialGauge';

export default RadialGauge;
